import Glide from '@glidejs/glide'

export default () => {
    return {
        carousel: null,

        prev() {
            this.carousel.go('<');
        },
        next() {
            this.carousel.go('>');
        },

        setPadding() {
        },

        mountCarousel(perView) {
            window.addEventListener("load", ()=>{
            this.carousel = new Glide(this.$refs.carousel, {
              type: perView > 1 ? 'carousel' : 'slider',
                autoplay: 6000,
                perView: perView,
                focusAt: 0,
            })
            this.carousel.mount()
        })
        },
    }
}



// WEBPACK FOOTER //
// ./scripts/steroids/slider.js